// Copyright © 2019 The Things Network Foundation, The Things Industries B.V.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import {
  GET_USER_ME_SUCCESS,
  GET_USER_ME_FAILURE,
  GET_USER_ME,
  LOGOUT_FAILURE,
  GET_USER_RIGHTS_SUCCESS,
} from '@console/store/actions/user'

const defaultState = {
  user: undefined,
  error: undefined,
  rights: undefined,
}

const user = function(state = defaultState, { type, payload }) {
  switch (type) {
    case GET_USER_ME:
      return {
        ...state,
        user: undefined,
        error: undefined,
      }

    case GET_USER_ME_SUCCESS:
      return {
        ...state,
        user: payload,
        error: undefined,
      }
    case GET_USER_ME_FAILURE:
      return {
        ...state,
        user: undefined,
        error: payload,
      }
    case GET_USER_RIGHTS_SUCCESS:
      return {
        ...state,
        rights: payload,
      }
    case LOGOUT_FAILURE:
      return {
        ...state,
        error: payload,
      }
    default:
      return state
  }
}

export default user
